/**
 * Geteilte Filter-Konstanten (Spec 409, Foundation).
 *
 * Eine einzige Quelle der Wahrheit fuer den „alle"-Sentinel der Single-Select-Filter.
 * Historisch ist der Sentinel uneinheitlich (`'all'` in services/transactions/webhooks/…,
 * `'__all__'` in der iq-service-inventory-Familie). Neue Bausteine und Stellen, die wir
 * ohnehin anfassen, nutzen ausschliesslich diese Konstante. Bestehende, in Spec 409 nicht
 * angefasste Filterleisten werden bewusst NICHT migriert (Blast-Radius-Grenze).
 */
export const FILTER_ALL_SENTINEL = '__all__';
